import { Type, type ViewType } from "~/models/dto";

export const DEFAULT_VIEW_TYPE: ViewType = {
	_type: Type.ViewType,
	name: "Default View Type",
	identifier: "urn:hardcoded:view-type:default-view",
	flags: [],
	filters: [],
	overview: {
		_type: Type.ViewTypeOverview,
		columns: [
			{
				_type: Type.ViewTypeTableColHealth,
			},
			{
				_type: Type.ViewTypeTableColName,
				title: "Component",
			},
			{
				_type: Type.ViewTypeTableColComponentType,
				title: "Type",
				width: 140,
			},
			{
				_type: Type.ViewTypeTableColTime,
				title: "Updated On",
				path: ["lastUpdateTimestamp"],
			},
		],
	},
};
